export enum Mitgliedschaft {
  KEINE = "KEINE",
  BASIS = "BASIS",
  PLUS = "PLUS",
  PREMIUM = "PREMIUM",
}
